import moment from 'moment';
import { getPriorityColor } from '../../utils/Helper';
import {Link} from 'react-router-dom'

const columns = [
  {
    name: 'Name',
    selector: (row) => (
      <Link to={`view/${row._id}`} className="hover:underline">
        {row.name}
      </Link>
    ),
  },
  {
    name: 'Priority',
    selector: (row) => {
      const priorityClass = getPriorityColor(row.priority);
      return (
        <span className={`px-2 py-1 rounded-full ${priorityClass}`}>
          {row.priority}
        </span>
      );
    },
  },
  {
    name: 'Company',
    selector: (row) => row.company,
  },
  {
    name: 'Assign To',
    selector: (row) => row.assignTo,
  },
  {
    name: 'Added Date',
    selector: (row) => moment(row.createdAt).format('DD/MM/YYYY hh:mm A'),
  },
  {
    name: 'Due Date',
    selector: (row) => moment(row.dueDate).format('DD/MM/YYYY hh:mm A'),
  },
  {
    name: 'Final Submit Date',
    selector: (row) => row.completionDate 
    ? moment(row.completionDate).format('DD/MM/YYYY hh:mm A') 
    : '-'
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
];

export default columns;
